import Vue from 'vue';
import jQuery from 'jquery'
import { GUPPYCHAT_SETTINGS } from '../../resources/constants';
// import GuppyChatManager from "../../resources/controller";
export const TabState = {
    // chatInfo                : {
    //   private : {},
    //   group   : {},
    //   post    : {},
    // },
    chatInfo : {},
    // private chat properties
    privateChatOffset       : 0,
    noMorePrivateChat       : false,
    privateConvFlag         : false,
    privateChatSearch       : '',
    privateConversation     : {},
    privateChatCount        : 0,
    // group chat properties
    groupChatOffset         : 0,
    noMoreGroupChat         : false,
    groupConvFlag           : false,
    groupChatSearch         : '',
    groupConversation       : {},
    groupChatCount          : 0,

    // post chat properties
    postListFlag            : false,
    postListOffset 	        : 0,
    noMorePostUsers         : false,
    postUserSearch          : '',
    postConversation        : {},
    postmessagesCount       : 0,

    // contacts list properties
    contactListFlag         : false,
    contactListOffset 	    : 0,
    noMoreContactUsers      : false,
    contactUserSearch       : '',
    contactList             : {},
    // requests list properties
    requestListFlag         : false,
    requestListOffset 	    : 0,
    noMoreRequesttUsers     : false,
    requestUserSearch       : '',
    requestList             : {},
    requestCount            : 0,
    // friend list properties
    friendListFlag          : false,
    friendListOffset 	      : 0,
    noMoreFriendUsers       : false,
    friendUserSearch        : '',
    friendList              : {},
    // Block user list properties
    blockListFlag           : false,
    blockListOffset 	      : 0,
    noMoreBlockUsers        : false,
    blockUserSearch         : '',
    blockList               : {},
    windowWidth             : 0
}
export const ActionsActions = {
    startConversation(context, payload ) {
        context.commit('startConversation', payload)
    },
}
export const TabMutations = {

  removeContactListItem( state, payload){
    Vue.delete(state.contactList, payload.chatId);
  },
  updateWidgetType( state, payload){
    if( 'isMessangerChat' in payload ) {
      state.isMessangerChat = payload.isMessangerChat;
      if(state.isMobileView){
        state.chatInfo = new Object();
      }
    }

    if( 'isMobileView' in payload ) {
      state.isMobileView = payload.isMobileView;
    }

  },
  updateChatInfo( state, payload ){
    if(Object.keys(payload).length == 0){
      Vue.set(state, 'chatInfo', {});
    }else{
      if(state.isMessangerChat){
        Vue.set(state, 'chatInfo', payload.data);
      }else{
        let windowWidth = state.windowWidth;
        let totalWindows = 3;
        if(windowWidth < 1141){
          totalWindows = 1;
        }else if(windowWidth < 1601){
          totalWindows = 2;
        } 
        let chatId = payload.data.chatId;
        let recExist = false;
        let userClick = false;
        if(Object.prototype.hasOwnProperty.call(state.chatInfo, chatId ) ){
          recExist = true;
        }
        if(payload.userClick){
          userClick = true;
        }
        let openChatWindows = Object.values(state.chatInfo).filter(chat => chat.isMinimize == false);
        if(openChatWindows.length == totalWindows){
          if(userClick){
            if(!recExist){
              Vue.set( state.chatInfo[openChatWindows[0].chatId],'isMinimize',  true);
              payload.data['isMinimize'] = false;
              Vue.set(state.chatInfo, chatId, payload.data);
            }else{
              let recIndex = openChatWindows.findIndex( (chat => chat.chatId == chatId) );
              if(recIndex == -1){
                let record = {};
                record = state.chatInfo[chatId];
                record.isMinimize = false;
                Vue.delete(state.chatInfo, chatId);
                Vue.set(state.chatInfo, chatId, record);
                Vue.set( state.chatInfo[openChatWindows[0].chatId],'isMinimize',  true);
              }
            }
          }else{
            if(!recExist){
              payload.data['isMinimize'] = true;
              Vue.set(state.chatInfo, chatId, payload.data);
            }
          }
        }else{
          if(userClick){
            if(recExist){
              let record = {};
              record = state.chatInfo[chatId];
              record.isMinimize = false;
              Vue.delete(state.chatInfo, chatId);
              Vue.set(state.chatInfo, chatId, record);
            }else{
              payload.data['isMinimize'] = false;
              Vue.set(state.chatInfo, chatId, payload.data);
            }
          }else{
            if(recExist){
              let recIndex = openChatWindows.findIndex( (chat => chat.chatId == chatId) );
              let isMinimize = true;
              if(recIndex != -1){
                isMinimize = false;
              }
              payload.data['isMinimize'] = isMinimize;
              Vue.set(state.chatInfo, chatId, payload.data);
            }else{
              payload.data['isMinimize'] = true;
              Vue.set(state.chatInfo, chatId, payload.data);
            }
          } 
        }
      }
    }
  },
  unseenCountMessage( state, payload ){
    state.groupChatCount    = payload.groupChatCount;
    state.postmessagesCount = payload.postmessagesCount;
    state.privateChatCount  = payload.privateChatCount;
    state.requestCount      = payload.requestCount;
  },
  updateTabListRecord(state, payload){
    if( Object.keys(state[payload.listType]).length && payload.isScrolling){
      let data = {...state[payload.listType], ...payload.list}
      Vue.set(state, payload.listType, data)
    } else {
      Vue.set(state, payload.listType, payload.list)
    }

  },
    selectTab( state, payload ){
      let enableTabs = GUPPYCHAT_SETTINGS.enabledTabs;
      if( enableTabs.includes(payload) ) {
        state.activeTab = payload;
      }
    },
    startChat( state, payload){
      let friendData      = payload.friendData;
      let messagelistData = payload.messagelistData;
      let chatId          = friendData.chatId;
          Vue.delete(state.contactList, chatId);

          let conversationData = {
            ...friendData,
            'isSender' : true,
            'message'  : messagelistData.message,
            'isStartChat'  : messagelistData.isStartChat,
            'blockedId'  : messagelistData.blockedId,
            'messageId'  : messagelistData.messageId,
            'messageStatus'  : messagelistData.messageStatus,
            'messageType'  : messagelistData.messageType,
            'muteNotification'  : false,
            'timeStamp' : messagelistData.timeStamp,
            'isMinimize' : false,
          }

          state.activeTab   = "messages"; 

          if(!Object.prototype.hasOwnProperty.call(state.friendList, chatId ) && !friendData.isBlocked){
            const updateRecord = Object.assign({ chatId: friendData}, state.friendList);
            Vue.set(state, 'friendList', updateRecord );
          }

          if(!Object.prototype.hasOwnProperty.call(state.privateConversation, chatId ) ){
            const updatedConversation = Object.assign({ chatId: conversationData}, state.privateConversation);
            Vue.set(state, 'privateConversation', updatedConversation) 
          }

          if(state.isMessangerChat){
            Vue.set(state, 'chatInfo', conversationData);
          } else {
            Vue.set(state.chatInfo, chatId, conversationData);
          }

          jQuery('.at-chat').addClass('at-auto-start-chat');
    },
    //push record to tab List
    updateRecList( state, payload ){ // just only use for update groupMembers list when create group
        let data = payload;
        if( state[data.listType].length && data.isScrolling){
            data.list.forEach( item => {
                let recordIndex = state[data.listType].findIndex( (user => Number(user.userId) == Number(item.userId) ) );
                if(recordIndex == -1){
                    Vue.set(state[data.listType], state[data.listType].length ,item)
                }
            });
        } else {
            state[data.listType] = [];
            state[data.listType] = data.list;
        }
    },
    updateConversationMessage(state, payload){
      let chatId = payload.chatId;
      let chatType = payload.chatType;
      let listType = '';
      if(chatType == 0){
        listType = 'postConversation';
      }else if(chatType == 1){
        listType = 'privateConversation';
      }else if(chatType == 2){
        listType = 'groupConversation';
      }
      if(payload.messageId){   // for delete message
        if(Object.prototype.hasOwnProperty.call(state[listType], chatId ) && state[listType][chatId].messageId == payload.messageId){
          state[listType][chatId].messageStatus = 2;
        }
      }else if(payload.messagelistData){
        let data           = JSON.parse(JSON.stringify(payload.messagelistData));
        data['clearChat'] = false;
        let unReadCount = 0;
        if( Object.prototype.hasOwnProperty.call(state[listType], chatId ) ){
          Vue.delete(state[listType], chatId);
        }
        if(state.isMessangerChat){      // for messanger base chat
          if(Object.keys(state.chatInfo).length === 0  || (state.chatInfo.chatId != chatId || state.chatInfo.chatType != chatType) ){
            unReadCount = data.UnreadCount;
          }
          if(data.chatType == 2){
            if(state.chatInfo && state.chatInfo.chatId == chatId && state.chatInfo.chatType == data.chatType){
              Vue.set(state, 'chatInfo', data);
            }
          }else if(data.isStartChat){
            Vue.set(state, 'chatInfo', data);
          }
        }else{
          let openChatWindow = Object.values(state.chatInfo).filter(chat => chat.isMinimize == false && chat.chatId == chatId).length;
          if(openChatWindow == 0){
            unReadCount = data.UnreadCount;
          }
          let userClick = false; 
          if(data.isStartChat){
            userClick = true;
          }
          if(!state.isMobileView){
            this.commit("updateChatInfo", { data, userClick });
          }
        }
        if(Number( unReadCount ) > 0 ){
          if(data.chatType == 0){
            let counter = state.postmessagesCount + 1;
            Vue.set(state, 'postmessagesCount', counter);
          }else if(data.chatType == 1){
            let counter = state.privateChatCount + 1;
            Vue.set(state, 'privateChatCount', counter);
          }else if(data.chatType == 2){
            let counter = state.groupChatCount + 1;
            Vue.set(state, 'groupChatCount', counter);
          }
        }
        data.UnreadCount  = unReadCount;
        let record = new Object();
        record[chatId] = data;
        let newConvList   = {...record, ...state[listType]};
        Vue.set(state, listType, newConvList); 
      }
    },
    updateWindowWidth(state, payload){
      state.windowWidth = payload.windowWidth;
    }
} 